import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import ThemeContext from '../utils/theming';

import { isPortrait } from '../utils/size';

const Button = styled.button`
    flex: 1;
    padding: 1em 0.25em;
    line-height: 0;
    background-color: ${props =>
        props.isDisabled && !props.isSubmitting
            ? 'white'
            : props.primary
            ? props.theme.colors.primary
            : 'white'};
    border: solid 1px
        ${props =>
            props.isDisabled && !props.isSubmitting
                ? '#e5e3e3'
                : props.primary
                ? props.theme.colors.primary
                : '#e5e3e3'};
    color: ${props =>
        props.isDisabled && !props.isSubmitting
            ? '#cbc8c8'
            : props.primary
            ? '#ffffff'
            : props.theme.colors.secondary};
    font-family: Averta;
    font-weight: 600;
    font-size: ${props =>
        props.label.length > 9 && props.shouldScale && !isPortrait() ? 13 : 16}px;
    height: 46px;
    cursor: ${props => (props.isDisabled ? `not-allowed` : `pointer`)};
    border-radius: 4px;
    position: relative;

    &:hover {
        ${props =>
            !props.primary &&
            `
                color: #fff;
                background-color: ${props.theme.colors.secondary};
                border: solid 1px ${props.theme.colors.secondary};
            `};
    }

    @media (max-width: 22em) {
        padding: 1em 6px;
    }
`;

const PhoneNumber = styled.a`
    color: #fff;
    text-decoration: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    line-height: 100%;
    padding: calc(1em - 2px);
`;

const ButtonComponent = props => {
    const theme = useContext(ThemeContext);
    return (
        <Button
            theme={theme}
            shouldScale={props.scale}
            style={props.style}
            className={props.className}
            label={props.label}
            primary={props.primary}
            type={props.type || 'button'}
            isSubmitting={props.isSubmitting}
            onClick={props.onClick}
            isDisabled={props.disabled || props.isSubmitting}
        >
            {!!props.normalizedPhone && props.normalizedPhone !== '' ? (
                <PhoneNumber
                    theme={theme}
                    target="_parent"
                    href={`tel:${props.normalizedPhone}`}
                >
                    {props.label}
                </PhoneNumber>
            ) : (
                <span>{props.label}</span>
            )}
        </Button>
    );
};

ButtonComponent.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    label: PropTypes.string.isRequired,
    normalizedPhone: PropTypes.string,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    scale: PropTypes.bool,
    style: PropTypes.object,
    type: PropTypes.string
};

export default ButtonComponent;
